<!-- @format -->

<ng-container *transloco="let t">
  <fudis-heading [level]="headingLevel">
    {{ module.name | localizedString }}{{ targetCredits ? " (" + (targetCredits | creditRange: "TEXT") + ")" : "" }}
  </fudis-heading>
  <fudis-grid [columns]="{ md: 'auto 25rem' }" [rowGap]="'xxs'">
    <fudis-body-text>{{ module.code }}{{ studyLevel ? " | " + (studyLevel | codeLocalizedName | async) : "" }}</fudis-body-text>
    <fudis-grid-item></fudis-grid-item>
    <fudis-breadcrumbs
      [label]="'SIS_COMPONENTS.PLAN.STUDY_MODULE_PARENT_HIERARCHY' | translate: { moduleName: (module.name | localizedString) }"
      [class]="'fudis-mb-none'">
      @for (parent of parents; track $index) {
        <fudis-breadcrumbs-item>
          <a
            fudisLink
            (click)="openModuleInfo(parent)"
            [title]="
              (parent.name | localizedString) + (parent.targetCredits ? ' (' + (parent.targetCredits | creditRange: 'TEXT') + ')' : '')
            "></a>
        </fudis-breadcrumbs-item>
      }
      <fudis-breadcrumbs-item>
        <fudis-body-text></fudis-body-text>
      </fudis-breadcrumbs-item>
    </fudis-breadcrumbs>
    <fudis-grid-item [alignSelfX]="'end'">
      <sis-plan-structure-module-selection-state [stateObject]="moduleStateObject" />
    </fudis-grid-item>
  </fudis-grid>
  <fudis-hr />
  <fudis-dl [classes]="'fudis-mt-sm'" [variant]="'compact'" [columns]="'1fr 3fr'" [width]="'xs'">
    <fudis-dl-item>
      <fudis-dt [contentText]="t('SIS_COMPONENTS.PLAN.LABEL.SELECTED_CREDITS')" />
      <fudis-dd [contentText]="(moduleStateObject?.moduleValidationResult?.plannedCredits | creditRange) ?? '-'" />
    </fudis-dl-item>
    <fudis-dl-item>
      <fudis-dt [contentText]="t('SIS_COMPONENTS.PLAN.LABEL.ATTAINED')" />
      <fudis-dd [contentText]="getAttainedCreditsText(t('CREDITS'))" />
    </fudis-dl-item>
  </fudis-dl>
  <fudis-grid [columns]="{ sm: 2, lg: 3 }">
    @for (courseUnitId of moduleStateObject.selectedCourseUnitIds; track courseUnitId) {
      @if (courseUnitId | courseUnit | async; as courseUnit) {
        <sis-plan-structure-course-unit
          [courseUnit]="courseUnit"
          [planStateObject]="planStructureData.planStateAndData.planStateObject"
          [planData]="planStructureData.planStateAndData.planData"
          [headingLevel]="headingLevel + 1"
          [nameClickable]="false">
        </sis-plan-structure-course-unit>
      }
    }
  </fudis-grid>
</ng-container>
